import React from 'react';
import EventColumn from '../../shared/component/dataTable/columns/EventColumn';
import AuditEventService from "../../shared/service/AuditEventService";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import Dialog from "../../shared/component/dialog/Dialog";
import AuditEventLog from "./AuditEventLog";
import DataTableLog from "../../shared/component/dataTable/DataTableLog";

export default class Event extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            tableName: this.props.tableName,
            tableId: this.props.tableId
        };
        this.service = new AuditEventService();
    }

    render() {
        return (
            <div>
                {GeneralUtils.checkPrivilege(this.props.objectName, 'ViewHistory') &&
                <DataTableLog ref={(elem) => this.refDataTable = elem} fields={EventColumn.fields} dataURL="auditEvent/findEventByEntityNameAndEntityId" objectName={this.props.objectName}
                    // selectionMode="single" onDataSelect={this.onDataSelect}
                              autoLoad={false}/>
                }

                <Dialog visible={this.state.displayDialog} header="Tarihçe Detay İzleme" modal={true} resizable={true}
                        maximizable={true}
                        responsive={true} onHide={() => this.setState({displayDialog: false})} style={{width: '60%'}}>
                    <AuditEventLog ref={elem => this.refAuditEventLog = elem}/>
                </Dialog>
            </div>
        );
    }

    onDataSelect = (data) => {
        if(data.eventType === 'ADD'){

        }else {
            this.setState({displayDialog: true});
            this.refAuditEventLog.setData(data.id);
        }
    }

    setData = (entityName, entityId) => {
        if (!GeneralUtils.isNullOrEmpty(entityName) && !GeneralUtils.isNullOrEmpty(entityId)) {
            this.refDataTable.setParameter(entityName, entityId);
            // this.service.findEventByEntityNameAndEntityId(entityName, entityId).then(response => this.setState({data: response}));
        }
    }
}

